// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/*
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community/util': []
})(this, function (m_module, Backbone, $, moment, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.Model = M.Community.Model || {};

  /**
   * @class M.Community.Model.Challenge
   *
   */
  M.Community.Model.Challenge = Backbone.Model.extend({
    initialize: function() {
      M.required(this.get('state'));
    },

    /**
     * Returns title to be displayed in challenge hub banner according to
     * challenge state
     *
     * @return {String} banner date title to display besides date
     */
    getDeadlineLabelText: function() {
      return M.COMMUNITY.CHALLENGE.STATUS_TEXT_DICT[this.get('state')][
        'deadlineLabelText'];
    },

    /**
     * Returns the action button url for the action button for the submission state
     *
     * @return {String} contest url for the current challenge
     */
    getActionButtonUrl: function() {
      if (this.get('state') == M.Config['ChallengeConfig'].state.submission.id) {
        return '/challenge/' + this.get('id') + '/submit';
      }
      if (this.get('state') === M.Config['ChallengeConfig'].state.vote.id) {
        return '/design-vote/' + this.get('id');
      }
      return ''
    },

    /**
     * Returns date that should display in challenge hub banner according to
     * challenge state
     *
     * If no moment format specified, then defaults to "dddd, MMMM DD, YYYY"
     *
     * @param momentFormat {String} format to moment.js for date to display as
     * @return {String} string for date to display - or empty string if no date
     *   to show
     */
    getBannerDateStr: function(momentFormat) {
      if (typeof momentFormat === 'undefined') {
        momentFormat = 'dddd, MMMM DD, YYYY';
      }

      var state = this.get('state');
      var dateToShow = null;
      if (state === M.Config['ChallengeConfig'].state.setup.id) {
        dateToShow = this.get('submission_start_date');
      } else if (state === M.Config['ChallengeConfig'].state.submission.id) {
        dateToShow = this.get('submission_end_date');
      } else if (state === M.Config['ChallengeConfig'].state.submission_closed.id) {
        if (this.get('nominate_start_date')) {
          dateToShow = this.get('nominate_start_date');
        } else {
          dateToShow = this.get('voting_start_date');
        }
      } else if (state === M.Config['ChallengeConfig'].state.nominate.id) {
        dateToShow = this.get('nominate_end_date');
      } else if (state === M.Config['ChallengeConfig'].state.nominate_select.id) {
        dateToShow = this.get('voting_start_date');
      } else if (state === M.Config['ChallengeConfig'].state.restricted_vote.id) {
        dateToShow = this.get('voting_start_date');
      } else if (state === M.Config['ChallengeConfig'].state.restricted_vote_closed.id) {
        dateToShow = this.get('voting_start_date');
      } else if (state === M.Config['ChallengeConfig'].state.vote.id) {
        dateToShow = this.get('voting_end_date');
      } else if (state === M.Config['ChallengeConfig'].state.vote_closed.id) {
        // return empty string - we don't want to show a date
        dateToShow = null;
      } else if (state === M.Config['ChallengeConfig'].state.published.id) {
        dateToShow = this.get('publish_date');
      }

      if (dateToShow) {
        return moment(dateToShow).format(momentFormat);
      }

      return '';
    }
  });

  return {
  };

});
